/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NatureFxLightningAIcon32Regular = forwardRef('NatureFxLightningAIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.868 4.648A2 2 0 0 1 10.838 3h8.336a2 2 0 0 1 1.923 2.55L19.254 12h4.156c1.68 0 2.612 1.946 1.558 3.255L12.975 30.143c-.968 1.201-2.902.334-2.648-1.188L11.987 19H8.693a2 2 0 0 1-1.969-2.352l2.143-12ZM19.174 5h-8.337L8.694 17h3.882a1.5 1.5 0 0 1 1.48 1.747l-1.443 8.656L23.41 14h-4.819a1.5 1.5 0 0 1-1.442-1.912L19.174 5Z" })));
});
